import request from '@/utils/request'

export function addTeacher(data){
  return request({
    url:'/schools/add-teacher',
    method:'post',
    data
  })
}

export function addClassroom(data){
  return request({
    url:'/schools/classes',
    method:'post',
    data
  })
}

export function deleteClassroom(id){
  return request({
    url:'/schools/classes/'+id,
    method:'delete'
  })
}

export function deleteTeacher(data){
  return request({
    url:'/schools/remove-teacher',
    method:'delete',
    data
  })
}

export function deleteStudent(data){
  return request({
    url:'/schools/remove-student',
    method:'delete',
    data
  })
}

export function addStudent(data){
  return request({
    url:'/schools/add-student',
    method:'post',
    data
  })
}


export function getAdminId(id){
  return request({
    url:'/schools/manager?school_code='+id,
    method:'get'
  })
}

export function getClassroomList(page,limit){
  return request({
    url:'/schools/classes?page='+page+'&limit='+limit,
    method:'get'
  })
}



export function getTeacherClassroomList (id) {
  return request({
    url:'/school/teacher/classes?teacher_id='+id,
    method:'get'
  })
}

export function getSchoolTeacherList (page,limit) {
  return request({
    url:'/schools/teachers?page='+page+'&limit='+limit,
    method:'get'
  })
}

export function getClassroomStudentList (page,limit,id) {
  return request({
    url:'/school/class/students?page='+page+'&limit='+limit+'&class_id='+id,
    method:'get'
  })
}


export function getClassroomTaskStudentList (page,limit,id) {
  return request({
    url:'/school/class/tasks/scores?page='+page+'&limit='+limit+'&task_id='+id,
    method:'get'
  })
}

export function setManagerToClassroom (data) {
  return request({
    url:'/school/classes/manager',
    method:'put',
    data
  })
}


export function editManagerToClassroom (data,id) {
  return request({
    url:'/schools/classes/'+id,
    method:'put',
    data
  })
}

export function addStudentToClassroom (data) {
    return request({
      url:'/school/classes/add-student',
      method:'post',
      data
    })
}

export function addTeacherToClassroom (data) {
  return request({
    url:'/school/classes/add-teacher',
    method:'post',
    data
  })
}

export function editStudentInfo (data) {
  return request({
    url:'/school/classes/student',
    method:'put',
    data
  })
}


export function deleteStudentFormClassroom (data) {
  return request({
    url:'/school/classes/remove-student',
    method:'delete',
    data
  })
}


export function deleteTeacherFormClassroom (data) {
  return request({
    url:'/school/classes/remove-teacher',
    method:'delete',
    data
  })
}


export function getClassroomTeacherList (id) {
  return request({
    url:'/school/class/teachers?class_id='+id,
    method:'get'
  })
}


export function getStudentSchoolInfo () {
  return request({
    url:'/school/student/profile',
    method:'get'
  })
}


export function editTeacherMessage (data) {
  return request({
    url:'/schools/teacher',
    method:'put',
    data
  })
}
